import { type Chapter, type Manifest, type MediaItem, formatCounts, formatDuration, formatRange, formatTime } from '@seemantham/core';
import { background, stillKey, tileWidth } from '../lib/data';
import { ChevronLeft, Play } from './icons';

interface ChapterViewProps {
  manifest: Manifest;
  chapter: Chapter;
  onBack: () => void;
  onOpenItem: (item: MediaItem) => void;
}

export function ChapterView({ manifest, chapter, onBack, onOpenItem }: ChapterViewProps) {
  const items = chapter.itemIds
    .map((id) => manifest.items.find((item) => item.id === id))
    .filter((item): item is MediaItem => Boolean(item));

  return (
    <div className="app">
      <div className="viewer__bar">
        <button type="button" onClick={onBack} aria-label="Back to the day">
          <ChevronLeft />
        </button>
        <span className="viewer__time">{chapter.name ?? formatRange(chapter.startsAt, chapter.endsAt)}</span>
        <span className="viewer__count">{formatCounts(chapter.clipCount, chapter.photoCount)}</span>
      </div>
      <div className="grid">
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            className="card"
            onClick={() => onOpenItem(item)}
            aria-label={`${item.kind === 'clip' ? 'Clip' : 'Photo'}, ${formatTime(item.capturedAt)}`}
          >
            <span
              className="card__image"
              style={{ background: background(item.thumb, stillKey(item, tileWidth())), position: 'relative' }}
            >
              {item.kind === 'clip' ? (
                <span className="badge">
                  <Play />
                  {formatDuration(item.durationSec ?? 0)}
                </span>
              ) : null}
            </span>
            <span className="card__caption">{formatTime(item.capturedAt)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
